import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import './css/Login.css';

class Logout extends Component {

render() {

/*
if (!this.state.redirectToReferrer || !sessionStorage.getItem('userData')){
return (<Redirect to={'/'}/>)
}
*/
//console.log(sessionStorage.getItem('userData'));
sessionStorage.removeItem("userData");
sessionStorage.clear();
return (<Redirect to={'/login'}/>)
//return (localStorage);

}
}
export default Logout;